export default "__VITE_ASSET__4ea4674c__"